import { useFormContext, useWatch } from 'react-hook-form';

import { HookFormSelect } from 'components/hookForm';

import { AttributeFormFieldValues } from '../../../customAttributeModalForm.types';
import { attributeTypeFormAttributes } from '../../../utils/attributeTypeFormAttributes';

const items = Object.entries(attributeTypeFormAttributes).map(
  ([key, item]) => ({
    id: key,
    name: item.label,
    isDisabled: item.isDisabled,
  }),
);

/**
 * Represents the field for selecting the type of a custom attribute when
 * creating a custom attribute.
 */
export const TypeFormField = (): JSX.Element => {
  // TODO: [TEAMS-13693] remove omit after updating to RHF v8
  const { control, reset } =
    useFormContext<Omit<AttributeFormFieldValues, 'options'>>();
  const type = useWatch({ control, name: 'type' });

  return (
    <HookFormSelect
      control={control}
      label="Attribute type"
      name="type"
      componentProps={{
        items,
        selectedItems: [items.find((item) => item.id === type)!],
        disabledItems: items
          .filter((item) => item.isDisabled)
          .map((item) => item.id),
        onChange: (items) => {
          if (type !== items[0].id) {
            reset({
              type: items[0].id,
              data_type: attributeTypeFormAttributes[items[0].id].data_type,
              label: '',
              identifier: '',
              description: '',
              is_required: false,
              visibility_condition: null,
            });
          }
        },
      }}
    />
  );
};
